import { render, staticRenderFns } from "./AddEmployment.vue?vue&type=template&id=388485a2"
import script from "./AddEmployment.vue?vue&type=script&lang=js"
export * from "./AddEmployment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports